import { api } from "../../../services/Api";
import { baixarBlobUrl } from "./prescricaoArquivos";

export function nomeArquivoAgendamentoPdf({ agendamentoId, tipoDocumento = "resumo" } = {}) {
  if (agendamentoId) {
    return `agenda-care-agendamento-${agendamentoId}.pdf`;
  }

  return `agenda-care-${tipoDocumento}.pdf`;
}

export async function buscarBlobAgendamentoPdf(agendamentoId) {
  const { data } = await api.get(`/v2/agendaCare/agendamento/${agendamentoId}/pdf`, {
    responseType: "blob",
  });

  return new Blob([data], { type: "application/pdf" });
}

export async function buscarBlobAgendamentoPdfPreview(payload) {
  const { data } = await api.post("/v2/agendaCare/agendamento/pdf", payload, {
    responseType: "blob",
  });

  return new Blob([data], { type: "application/pdf" });
}

export function baixarAgendamentoPdfUrl(blobUrl, opcoes) {
  baixarBlobUrl(blobUrl, nomeArquivoAgendamentoPdf(opcoes));
}
